<template>
  <div
    class="shipment-tracking-progress-bar flex flex-column flex-gap-1 flex-grow-1"
  >
    <ProgressBar :value="progress" :show-value="false" />

    <div class="flex flex-row flex-gap-1 align-items-center">
      <div v-if="complete" class="icon-background">
        <i class="pi pi-check" aria-hidden="true" />
      </div>
      <div v-else-if="inProgress" class="circle"></div>
      <div v-else class="circle gray"></div>
      {{ label }}
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, toRefs } from 'vue';

import ProgressBar from 'primevue/progressbar';

const props = defineProps({
  label: {
    type: String,
    required: true,
  },
  inProgress: {
    type: Boolean,
    required: true,
  },
  complete: {
    type: Boolean,
    required: true,
  },
});
const { label, inProgress, complete } = toRefs(props);

const progress = computed(() => {
  if (complete.value) {
    return 100;
  } else if (inProgress.value) {
    return 50;
  } else {
    return 0;
  }
});
</script>

<style>
.shipment-tracking-progress-bar {
  .p-progressbar {
    background: var(--success-light-color);
    height: var(--sp-2);
    border-radius: var(--sp-1);

    .p-progressbar-value {
      background: var(--success-color);
    }

    .in-progress {
      width: 50%;
      background-color: rgba(rgb(47, 82, 47), 1);
      align-self: flex-end;
    }

    .complete {
      width: 100%;
      background-color: var(--success-color);
    }
  }

  .icon-background {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background-color: var(--success-color);
    color: white;
    min-width: 1em;
    width: var(--sp-4);
    height: var(--sp-4);
    border-radius: 50%;
    vertical-align: center;

    .pi.pi-check {
      font-size: 10px;
    }
  }

  .circle {
    border: 2px solid var(--success-color);
    border-radius: 50%;
    width: var(--sp-4);
    height: var(--sp-4);

    &.gray {
      border: 2px solid var(--info-light-color);
    }
  }
}
</style>
